import { OrgCard } from './OrgCard';
import { OrgProgressBar } from './OrgProgressBar';
import { Sparkline } from './Sparkline';

type Accent = 'orange' | 'teal' | 'blue';
const ACCENT: Record<Accent, string> = { orange: '#ff5a1f', teal: '#0f766e', blue: '#2563eb' };

export function KpiCard({
  label, value, caption, delta, series, accent, progressPct,
}: {
  label: string;
  value: string;
  caption: string;
  delta?: number;
  series?: number[];
  accent: Accent;
  progressPct?: number;
}) {
  const color = ACCENT[accent];
  const barClassName = accent === 'orange' ? 'bg-[#ff5a1f]' : accent === 'teal' ? 'bg-[#0f766e]' : 'bg-[#2563eb]';

  return (
    <OrgCard className="flex min-h-[210px] flex-col p-[25px]">
      <div className="flex items-center justify-between pb-3">
        <span className="text-sm font-medium text-[#6b7280]">{label}</span>
      </div>
      <div className="flex items-start justify-between">
        <div>
          <p className="text-5xl font-bold leading-none text-[#111827]">{value}</p>
          {delta !== undefined && (
            <p className={`mt-2 text-xs font-medium ${delta >= 0 ? 'text-[#0f766e]' : 'text-red-600'}`}>
              {delta >= 0 ? '↑' : '↓'} {Math.abs(delta)}% from last week
            </p>
          )}
        </div>
        {series && series.length >= 2 && <Sparkline values={series} stroke={color} />}
      </div>
      <div className="mt-auto pt-4">
        {progressPct !== undefined && (
          <OrgProgressBar pct={progressPct} barClassName={barClassName} className="mb-2" />
        )}
        <p className="text-xs text-[#9ca3af]">{caption}</p>
      </div>
    </OrgCard>
  );
}
